export interface AdStyle {
  id: string;
  image_url: string;
  name?: string;
}

export interface AdStyleCategory {
  category: "all" | "viral" | "offer" | "testimonials" | "custom";
  images: AdStyle[];
}

export const adStylesMock: AdStyleCategory[] = [
  {
    category: "all",
    images: [
      {
        id: "1",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V1",
      },
      {
        id: "1",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V1",
      },
      {
        id: "2",
        image_url: "https://fluxi.co/dev/assets/fa288c7214a641b7863b19586b998e9/products/variations/bf2aa3f5/variation_73bceac4.webp",
        name: "Testing Template V2",
      },
      {
        id: "3",
        image_url: "https://fluxi.co/prod/assets/svgs/fluxi-pet-2.svg",
        name: "Testing Template V3",
      },
      {
        id: "4",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V4",
      },
      {
        id: "5",
        image_url: "https://fluxi.co/dev/assets/fa288c7214a641b7863b19586b998e9/products/variations/bf2aa3f5/variation_73bceac4.webp",
        name: "Testing Template V5",
      }
    ],
  },
  {
    category: "viral",
    images: [
      {
        id: "v1",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V1",
      },
      {
        id: "v2",
        image_url: "https://fluxi.co/dev/assets/fa288c7214a641b7863b19586b998e9/products/variations/bf2aa3f5/variation_73bceac4.webp",
        name: "Testing Template V2",
      },
      {
        id: "v3",
        image_url: "https://fluxi.co/prod/assets/svgs/fluxi-pet-2.svg",
        name: "Testing Template V3",
      },
    ],
  },
  {
    category: "offer",
    images: [
      {
        id: "o1",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V1",
      },
      {
        id: "o2",
        image_url: "https://fluxi.co/dev/assets/fa288c7214a641b7863b19586b998e9/products/variations/bf2aa3f5/variation_73bceac4.webp",
        name: "Testing Template V2",
      },
      {
        id: "o3",
        image_url: "https://fluxi.co/prod/assets/svgs/fluxi-pet-2.svg",
        name: "Testing Template V3",
      },
      {
        id: "o4",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V4",
      },
    ],
  },
  {
    category: "testimonials",
    images: [
      {
        id: "t1",
        image_url: "https://fluxi.co/dev/assets/fa288c7214a641b7863b19586b998e9/products/variations/bf2aa3f5/variation_73bceac4.webp",
        name: "Testing Template V1",
      },
      {
        id: "t2",
        image_url: "https://fluxi.co/prod/assets/svgs/fluxi-pet-2.svg",
        name: "Testing Template V2",
      },
      {
        id: "t3",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V3",
      },
    ],
  },
  {
    category: "custom",
    images: [
      {
        id: "c1",
        image_url: "https://fluxi.co/prod/assets/svgs/fluxi-pet-2.svg",
        name: "Testing Template V1",
      },
      {
        id: "c2",
        image_url: "https://fluxi.s3.amazonaws.com/prod/assets/ads/cretives/templates/testing-template-v1",
        name: "Testing Template V2",
      },
    ],
  },
];

